import styled from '@emotion/styled';
import { space, variant } from 'styled-system';
import { StyledProps } from './MenuItem.types';
import { Theme } from './../Menu.types';
import css from '@styled-system/css';

const activeMenuItem = css({
  bg: 'var(--color-putty)',
  color: 'var(--color-smoke)',
  fontWeight: 'bold',
  '&:hover': {
    border: '1px solid transparent',
  },
});

const disabledMenuItem = css({
  bg: 'var(--color-neutral-15)',
  color: ' var(--color-smoke-50)',
  cursor: 'not-allowed',
  '&:hover': {
    border: '1px solid transparent',
  },
  '*': {
    fill: 'var(--color-smoke-50)',
  },
});

export const MenuItemContainer = styled.div<StyledProps, any>`
  ${space}
  ${css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '48px',
    py: 3,
    px: 4,
    color: 'var(--color-smoke)',
    borderRadius: '4px',
    cursor: 'pointer',
    border: '1px solid transparent',
    '&:hover': {
      border: 'solid',
      borderWidth: '1px',
      borderColor: 'var(--color-neutral-5)',
    },
  })}
  ${(p) => p.isActive && activeMenuItem}
  ${(p) => p.isDisabled && disabledMenuItem}
`;

export const MenuItemTitle = styled.span<StyledProps, Theme>`
  ${space}
  ${css({
    fontSize: '16px',
    marginLeft: '16px',
  })}
`;

export const MenuLabel = styled.div<StyledProps, Theme>`
  ${space}
  ${css({
    display: 'flex',
    alignItems: 'center',
  })}
`;

export const MenuItemLiContainer = styled.li<StyledProps, Theme>`
  ${space}
  ${css({
    listStyle: 'none',
  })}
`;
